import { render, staticRenderFns } from "./votingBtn.vue?vue&type=template&id=8b636332&scoped=true"
import script from "./votingBtn.vue?vue&type=script&lang=js"
export * from "./votingBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b636332",
  null
  
)

export default component.exports